import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { rgba } from 'lib/styling/colors';
import common from '@material-ui/core/colors/common';

const StyledOverlay = styled(motion.div)({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: rgba(common.black, 0.5),
  // TODO: this is temporarily disabled due to a Chrome bug
  // backdropFilter: 'saturate(50%)',
  display: 'block',
  zIndex: 3
});

const PageOverlay = props => (
  <StyledOverlay
    initial={{ opacity: 0.5 }}
    animate={{ opacity: 1 }}
    {...props}
  />
);

export default PageOverlay;
